import { useState } from "react";
import { useHistory } from "react-router-dom";
import BaseButton from "components/common/BaseButton";
import BaseModal from "../shared/components/BaseModal";
import { useIntl } from "react-intl";
import { usAdminAppRoutes } from "../../../route-definitions";
import EntityPageLayout from "../shared/components/EntityPageLayout";
import { DistributorFormData } from "./components/create-distributor-form/create-distributor.schema";
import CreateDistributorForm from "./components/create-distributor-form/CreateDistributorForm";
import useMutateDistributor from "./hooks/useMutateDistributor";

const CreateDistributorPage = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const intl = useIntl();

  const {
    createDistributor,
    createDistributorLoading,
    createDistributorSuccess,
    createDistributorError,
  } = useMutateDistributor({
    onCreateSuccess: () => {
      setModalIsOpen(true);
    },
    onCreateError: () => {
      setModalIsOpen(true);
    },
  });

  const onSubmit = (data: DistributorFormData) => {
    createDistributor(data);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (createDistributorSuccess) {
      history.push(usAdminAppRoutes.distributors);
    }
  };

  return (
    <EntityPageLayout headerMessage="usAdmin.createDistributor">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {createDistributorSuccess && (
          <h2>
            {intl.formatMessage({
              id: "usAdmin.distributorCreatedSuccessfully",
            })}
          </h2>
        )}
        {createDistributorError && (
          <h2>{intl.formatMessage({ id: "usAdmin.distributorExists" })}</h2>
        )}
      </BaseModal>
      <CreateDistributorForm
        onSubmit={onSubmit}
        isSubmitting={createDistributorLoading}
      />
    </EntityPageLayout>
  );
};

export default CreateDistributorPage;
